import React from 'react';
import WhistleLandingBlock from '@/components/WhistleLandingBlock';
import TenantFooter from '@/components/TenantFooter';

// Institutional landing screen shown BEFORE the report form, for tenants
// that opted into `layout_style: 'whistle'`. Renders the CogniEtica-branded
// BRUMA-style layout with the tenant's slug displayed as the main brand.
export const WhistleLanding = ({ tenant, branding, onStart }) => (
  <div className="min-h-screen bg-white">
    <WhistleLandingBlock
      tenantSlug={tenant?.slug}
      tenantName={tenant?.name}
      heroImageUrl={branding?.hero_image_url}
      primaryColor={branding?.primary_color}
      institutionalText={branding?.institutional_text}
      supportEmail={branding?.support_email}
      supportSignature={branding?.support_signature}
      onStart={onStart}
      interactive
      sticky
    />
    <TenantFooter branding={branding} />
  </div>
);
